import React from 'react';
import PropTypes from 'prop-types';

import Loading from '../../shared/components/misc/Loading';

const propTypes = {
  paymentsSizeText: PropTypes.string.isRequired,
  total:            PropTypes.number.isRequired,
  daysBeforeDue:    PropTypes.string.isRequired,
  dueDateHumanized: PropTypes.string.isRequired,
  loading:          PropTypes.bool,
};

const UpcomingPayment = ({ paymentsSizeText, total, daysBeforeDue, dueDateHumanized, loading }) => {
  if (loading) return <Loading />;

  return (
    <section className='cardSection _textAlign_center'>
      <h2 className='subhead -darkBlue'>
        Your next <span data-testid='repayments-count'>{paymentsSizeText}</span>
        of <span className='-primary' data-testid='total-amount'>{total}</span> is due
        <br />
        <span data-testid='remaining-days-due'>{daysBeforeDue}</span>{dueDateHumanized}.
      </h2>
      <p className='byline --small'>Make sure your bank account has funds before this date.</p>
    </section>
  );
}

UpcomingPayment.propTypes = propTypes;
export default UpcomingPayment;



// WEBPACK FOOTER //
// ./src/features/home/components/UpcomingPayment.js